export default __webpack_public_path__ + "static/pix-794b6b3782239ae2ad2d8c1223e320f9.png";